/* =====================================================================================================================
   batida-v7-paczka.js: "Paczka na przyjęcie" (sections/batida-v7-paczka.liquid; prototype section #gc-calc, its
   function gc(n) and the P map). The prototype's hard-coded products and thresholds are section blocks now:
   config in [data-v7pk-cfg] = { items: {key: {title, sub, id, price, img, quote, avail, url}}, rules: [{upto, mode,
   keys, title}], extras* , t: texts }.
   Pack for n people: the first rule with n <= upto (the last rule for more), then mini deserki on top (from extrasFrom
   people, 1 set per extrasPer people, keys in turn) - exactly the prototype's gc(n).
   The message after adding: "{n} {pozycje}" with the Polish plural of the word (1 pozycja, 2-4 pozycje, 5+ pozycji).
   "Dodaj całą paczkę do koszyka": POST /cart/add.js { items: [{id, quantity}] } (plain products: no properties), full
   /cart.js -> theme:cart:change -> the cart drawer (window.__batidaOpenCart). "Wycena" items never go in the cart.
   ===================================================================================================================== */
(function () {
  'use strict';

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* 29.09 (Aleksandra): prices ALWAYS with grosze - "310,00 zł", "Razem 455,00 zł" (window.batidaMoney = the site-wide
     helper in layout/theme.liquid) */
  function money(cents) {
    if (window.batidaMoney) return window.batidaMoney(cents);
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' zł';
  }
  function list(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  /* Polish plural: forms = [1, 2-4 (22-24, ...), 5+ (also 12-14, 0)] - "1 pozycja", "2 pozycje", "5 pozycji", "12 pozycji" */
  function plural(n, forms) {
    var f = list(forms);
    if (!f.length) return '';
    if (f.length < 3) return n === 1 ? f[0] : (f[1] || f[0]);
    var d = n % 10, h = n % 100;
    if (n === 1) return f[0];
    if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return f[1];
    return f[2];
  }
  function addedText(tpl, count, forms) {
    var s = String(tpl || '');
    /* old saved text "... {n} pozycji ..." (before the {pozycje} placeholder): the word follows the number */
    if (s.indexOf('{pozycje}') < 0) s = s.replace(/\{n\}\s+pozycj[aei]\b/, '{n} {pozycje}');
    return s.replace(/\{pozycje\}/g, plural(count, forms)).replace(/\{n\}/g, count);
  }

  function init(root) {
    if (!root || root.hasAttribute('data-v7pk-ready')) return;
    root.setAttribute('data-v7pk-ready', '1');
    var C = {};
    try { C = JSON.parse(root.querySelector('[data-v7pk-cfg]').textContent); } catch (e) { return; }
    var T = C.t || {}, ITEMS = C.items || {};
    var MIN = +C.min || 1, MAX = +C.max || 60;
    var rules = (C.rules || []).map(function (r) { return { upto: +r.upto || 0, mode: r.mode, keys: list(r.keys), title: r.title || '' }; })
      .filter(function (r) { return r.keys.length; })
      .sort(function (a, b) { return a.upto - b.upto; });
    var extraKeys = list(C.extrasKeys).filter(function (k) { return ITEMS[k]; });

    var nEl = root.querySelector('[data-v7pk-n]'), range = root.querySelector('[data-v7pk-r]');
    var tEl = root.querySelector('[data-v7pk-t]'), listEl = root.querySelector('[data-v7pk-list]');
    var sumEl = root.querySelector('[data-v7pk-sum]'), addBtn = root.querySelector('[data-v7pk-add]');
    var change = root.querySelector('[data-v7pk-change]'), msg = root.querySelector('[data-v7pk-msg]');
    var minus = root.querySelector('[data-v7pk-d="-1"]'), plus = root.querySelector('[data-v7pk-d="1"]');
    var LAST = [], n = +C.start || 10, busy = false;

    /* the prototype's gc(n) */
    function build(n) {
      var L = [];
      function add(k, q) {
        if (!ITEMS[k] || q <= 0) return;
        for (var i = 0; i < L.length; i++) if (L[i][0] === k) { L[i][1] += q; return; }
        L.push([k, q]);
      }
      var rule = null;
      for (var i = 0; i < rules.length; i++) if (n <= rules[i].upto) { rule = rules[i]; break; }
      if (!rule) rule = rules[rules.length - 1];
      var title = '';
      if (rule) {
        title = rule.title.replace(/\{n\}/g, n);
        if (rule.mode === 'people') {
          var c = {}, order = [];
          for (var p = 0; p < n; p++) { var k = rule.keys[p % rule.keys.length]; if (!c[k]) { c[k] = 0; order.push(k); } c[k]++; }
          order.forEach(function (k) { add(k, c[k]); });
        } else {
          rule.keys.forEach(function (k) { add(k, 1); });
        }
      }
      if (extraKeys.length && +C.extrasFrom > 0 && n >= +C.extrasFrom) {
        var sets = Math.ceil(n / (+C.extrasPer || 20));
        for (var s = 0; s < sets; s++) add(extraKeys[s % extraKeys.length], 1);
      }
      return { title: title, lines: L };
    }

    function render() {
      n = Math.max(MIN, Math.min(MAX, Math.round(n)));
      nEl.textContent = n;
      range.value = n;
      if (minus) minus.disabled = n <= MIN;
      if (plus) plus.disabled = n >= MAX;
      var pack = build(n), sum = 0, quote = false, html = '';
      LAST = pack.lines;
      pack.lines.forEach(function (x) {
        var it = ITEMS[x[0]], q = x[1];
        var isQuote = it.quote || !it.price;
        if (isQuote) quote = true; else sum += it.price * q;
        html += '<div class="v7pk-it">' +
          '<span class="v7pk-img" data-v7-slot="@paczka-miniatura"' + (it.img ? (it.auto ? ' data-v7-slot-auto' : '') : ' data-v7-slot-empty') + '>' +
            (it.img ? '<img src="' + esc(it.img) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</span>' +
          '<div><b>' + (q > 1 ? q + ' × ' : '') + esc(it.title) + '</b>' + (it.sub ? '<span>' + esc(it.sub) + '</span>' : '') + '</div>' +
          '<em>' + (isQuote ? esc(T.quote) : money(it.price * q)) + '</em></div>';
      });
      tEl.textContent = pack.title;
      listEl.innerHTML = html;
      sumEl.textContent = (quote && T.from ? T.from + ' ' : '') + money(sum) + (quote && T.plusQuote ? ' ' + T.plusQuote : '');
      if (change) change.setAttribute('href', quote ? (C.quoteUrl || C.changeUrl) : C.changeUrl);
      addBtn.disabled = !LAST.some(function (x) { var it = ITEMS[x[0]]; return it && !it.quote && it.price && it.id; });
      if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
    }

    function set(v) { n = +v; render(); }
    root.addEventListener('click', function (e) {
      var d = e.target.closest('[data-v7pk-d]');
      if (d) { set(n + (+d.getAttribute('data-v7pk-d'))); return; }
      if (e.target.closest('[data-v7pk-add]')) addAll();
    });
    range.addEventListener('input', function () { set(range.value); });

    function cartRoot() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''); }
    function post(items) {
      return fetch(cartRoot() + '/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }
    function done(count, failed) {
      return fetch(cartRoot() + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } })); } catch (e) { /* old browsers */ }
      }).catch(function () { /* the drawer fetches the cart itself */ }).then(function () {
        if (msg) {
          msg.classList.toggle('is-err', !!failed);
          msg.textContent = failed ? T.error : addedText(T.added, count, T.addedWords || 'pozycja, pozycje, pozycji');
        }
        if (typeof window.__batidaOpenCart === 'function') window.__batidaOpenCart();
      });
    }
    function addAll() {
      if (busy) return;
      var items = [], count = 0;
      LAST.forEach(function (x) {
        var it = ITEMS[x[0]];
        if (!it || it.quote || !it.price || !it.id) return;
        items.push({ id: it.id, quantity: x[1] });
        count += x[1];
      });
      if (!items.length) return;
      busy = true;
      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      post(items).then(function (r) {
        if (r.ok) return done(count, 0);
        /* one of the products can't be added (e.g. sold out): add the rest one by one, then say so */
        var failed = 0, added = 0, p = Promise.resolve();
        items.forEach(function (it) {
          p = p.then(function () { return post([it]).then(function (r2) { if (r2.ok) added += it.quantity; else failed++; }).catch(function () { failed++; }); });
        });
        return p.then(function () { return done(added, failed); });
      }).catch(function () {
        msg.classList.add('is-err'); msg.textContent = T.error || '';
      }).then(function () {
        busy = false;
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
      });
    }

    render();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-v7pk]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
